<template>
    <v-container fluid grid-list-xs
            :data-watch-loader="watchLoader">
        <v-layout v-if="!isLoaded" justify-center align-center fill-height>
            <loader></loader>
        </v-layout>
        <v-layout v-if="isLoaded" row wrap>
          <v-flex xs12>
              <v-card>
                  <v-card-title>
                      <v-layout row wrap>
                          <v-flex lg6 md6 xs12>
                              <p class="title">Client: {{ $store.getters['clientsLocations/clientLocation'](visit.client_location_id).client.name }}</p>
                          </v-flex>
                          <v-flex lg6 md6 xs12 v-if="visit.machine.client_location">
                              <p class="subheading"><b>Locatie client:</b> {{ $store.getters['clientsLocations/clientLocation'](visit.client_location_id).name }}</p>
                          </v-flex>
                          <v-flex lg6 md6 xs12>
                              <p><b>Data:</b> {{filterDate(visit.updated_at)}}</p>
                          </v-flex>
                          <v-flex lg6 md6 xs12>
                              <p><b>Status:</b> {{this.$store.getters['visits/status'](visit.status).name}}</p>
                          </v-flex>
                          <v-flex lg6 md6 xs12>
                              <p><b>Aparat:</b> {{ visit.machine ? `${visit.machine.idstr} (${visit.machine.model.name})` : '' }}</p>
                          </v-flex>
                          <v-flex lg6 md6 xs12>
                              <p><b>Angajat:</b> {{ visit.employee ? visit.employee.name : '' }}</p>
                          </v-flex>
                          <v-flex lg6 md6 xs12>
                              <p><strong>Înregistrată de:</strong> {{ visit.created_by ? visit.created_by.name : '' }}</p>
                          </v-flex>
                          <v-flex lg6 md6 xs12 v-if="visit.agency">
                              <p><b>Sucursala:</b> {{ visit.agency.name }}</p>
                          </v-flex>
                          <v-flex lg6 md6 xs12 v-if="visit.machine.client_location">
                              <p><b>Contor general:</b> {{ visit.counter }}</p>
                          </v-flex>
                      </v-layout>
                  </v-card-title>
              </v-card>
          </v-flex>
        </v-layout>
        <v-layout v-if="isLoaded && visit.notes" row wrap>
            <v-flex xs12>
                <v-card>
                    <v-card-title class="headline">
                        Note
                    </v-card-title>
                    <v-card-text>
                      <p>{{visit.notes}}</p>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <v-layout v-if="isLoaded" row wrap mt-2>
            <v-flex xs12>
                <data-table v-if="visitActions.length"
                  @action="onRowAction"
                  :actions="actions"
                  :items="visitActions"
                  :headers="headers"
                  :entityName="entityName"/>
                <v-btn v-else block color="primary" dark @click="onActionAdd()">Adaugă acțiune</v-btn>
            </v-flex>
        </v-layout>

        <v-layout v-if="isLoaded && visit.status === 0 && visitActions.length" row wrap mt-2>
            <v-flex xs12>
                <v-btn :loading="processing" block color="success" dark @click="closeVisit()">Închide vizita</v-btn>
            </v-flex>
        </v-layout>

        <toast-message></toast-message>
        <edit-dialog v-if="dialogData"
            :entityName="entityName"
            :fields="fields"
            :isMobile="true"
            :fieldValues="dialogData"
            @status="onStatusChange"
            apiEndpoint="visitActions">
        </edit-dialog>
        <edit-dialog v-if="dialogDataVisit"
          entityName="Vizită"
          :fields="fieldsVisit"
          :isMobile="true"
          :fieldValues="dialogDataVisit"
          @status="onStatusChangeVisit"
          apiEndpoint="visits">
        </edit-dialog>
    </v-container>
</template>

<script>
import moment from 'moment';
import bus from '../bus';

export default {

  data() {
    return {
      isLoaded: false,
      processing: false,
      headers: [
        {
          text: 'Data',
          align: 'left',
          value: 'created_at',
          format: (item) => {
            return `<span class="v-chip white--text theme--dark ${this.$store.getters['visitActions/status'](item.status).color}"><span class="v-chip__content">${this.$store.getters['visitActions/status'](item.status).name}</span></span>${moment(item.created_at).format('DD/MM/YYYY HH:mm')}<br><b>${item.path} (${item.duration} minute)</b>`;
          },
          searchable: true
        }
      ],
      entityName: 'Acțiune',

      actions: [
        { name: 'Editează', color: '', event: 'edit' },
        { name: 'Șterge', event: 'delete', color: 'red' }
      ]
    };
  },
  computed: {
    dialogData: {
      get() {
        return this.$store.state.actions.dialog;
      },
      set(value) {
        this.$store.commit('actions/DIALOG', value);
      }
    },

    dialogDataVisit: {
      get() {
        return this.$store.state.visits.dialog;
      },
      set(value) {
        this.$store.commit('visits/DIALOG', value);
      }
    },

    visit() {
      return this.$store.state.visits.data.find(
        f => f.id === ~~this.$route.params.id
      );
    },

    visitActions() {
      return this.$store.state.visitActions.data;
    },

    fields() {
      return [
        {
          size: 'sm12',
          label: 'Stare',
          value: 'status',
          type: 'v-select',
          inputType: 'text',
          options: this.$store.state.visitActions.status,
          required: true
        },
        {
          size: 'sm12',
          label: 'Acțiune',
          value: 'action_id',
          type: 'action-selector'
        },
        {
          size: 'sm12',
          label: 'Durata (min)',
          value: 'duration',
          type: 'v-text-field',
          inputType: 'number',
          required: true
        },
        {
          size: 'sm12',
          label: 'Piesă',
          value: this.getSelectedActionProductType === 'stock' ? 'stock_id' : 'product_id',
          type: 'product-search',
          inputType: 'text',
          hide: (data) => {
            if (data.action_id) {
              const selectedAction = this.$store.getters['actions/action'](data.action_id);
              if (selectedAction) {
                return data.status === 1 && (selectedAction.path.includes('INLOCUI') || selectedAction.path.includes('DEMONTA') || selectedAction.path.includes('MONTA'));
              }
            }
            return false;
          },
          apiEndpoint: this.getSelectedActionProductType,
          required: true
        }
      ];
    },

    getSelectedActionProductType() {
      if (this.$store.state.actions.selectedItem) {
        if (this.path.includes('INLOCUI') || (this.path.includes('MONTA') && !this.path.includes('DEMONTA'))) {
          return 'stock';
        }
        return 'products';
      }
    },

    shouldShowProductField() {
      if (this.$store.state.actions.selectedItem) {
        return this.path.includes('INLOCUI') || this.path.includes('DEMONTA') || this.path.includes('MONTA');
      }
      return false;
    },

    fieldsVisit() {
      return [
        {
          size: 'sm6',
          label: 'Stare',
          value: 'status',
          type: 'v-select',
          inputType: 'text',
          options: this.$store.state.visits.status,
          required: true
        },
        {
          size: 'sm6',
          label: 'Aparat',
          value: 'machine_id',
          itemText: 'idstr',
          type: 'autocomplete-selector',
          required: true,
          apiEndpoint: 'machines'
        },
        {
          size: 'sm6',
          label: 'Contor general',
          value: 'counter',
          type: 'v-text-field',
          inputType: 'number',
          required: true
        },
        {
          label: 'Note',
          value: 'notes',
          type: 'v-textarea',
          inputType: 'text',
          box: true
        }
      ];
    },

    searchableColumns() {
      return this.headers.filter(i => i.searchable !== false);
    },

    watchLoader: {
      get() {
        if (this.isLoaded) {
          this.$store.commit('CENTER_VIEW_VERTICAL', false);
        } else {
          this.$store.commit('CENTER_VIEW_VERTICAL', true);
        }
      }
    },

    path() {
      return this.$store.state.actions.selectedItem ? this.$store.getters['actions/action'](this.$store.state.actions.selectedItem.id).path : '';
    }
  },

  created() {
    this.loadDependencies().then(() => {
      this.loadItem();
    });
  },

  methods: {
    loadItem() {
      this.$store
        .dispatch('visits/LOAD', { id: this.$route.params.id, filter: null })
        .then(() => {
          this.$store.dispatch('clientsLocations/LOAD_ONE', this.visit.client_location_id).then(() => {
            this.isLoaded = true;
          });
        });
    },

    loadDependencies() {
      return Promise.all([
        this.$store.dispatch('actions/LOAD', {filter: { rowsPerPage: -1 }}),
        this.$store.dispatch('employees/LOAD', {filter: { rowsPerPage: -1 }}),
        this.$store.dispatch('agencies/LOAD', {filter: { rowsPerPage: -1 }}),
        this.$store.dispatch('LOAD_USER')
      ]);
    },

    fullName(employee) {
      return `${employee.firstname} ${employee.lastname}`;
    },

    filterDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },

    onRowAction(event) {
      switch (event.name) {
        case 'edit':
          this.$store.commit('actions/FILTER', '');
          this.$store.commit('actions/SELECT', null);
          let visit = { ...event.data };
          visit.visit_id = this.visit.id;
          delete visit.created_at;
          delete visit.updated_at;
          this.$store.commit('actions/SELECT', visit.action);
          this.dialogData = visit;
          break;
        case 'add':
          this.onActionAdd();
          break;
        case 'delete':
          bus.$emit('confirmation-dialog-show', {
            title: 'Confirmare ștergere',
            text: `Sunteți sigur că doriți să ștergeți acțiunea ${
              event.data.action.name
            }?`,
            actionButton: 'Șterge',
            action: () => {
              this.$store
                .dispatch('visitActions/DELETE', event.data.id)
                .then(() => {
                  bus.$emit('toast-message-show', {
                    text: `Acțiunea ${event.data.action.name}  a fost ștearsă.`
                  });
                })
                .catch(() => {
                  bus.$emit('toast-message-show', {
                    error: true,
                    text: `A intervenit o eroare la ștergerea acțiunii ${
                      event.data.action.name
                    }.`
                  });
                });
            }
          });
          break;
      }
    },

    onAction(event) {
      switch (event) {
        case 'edit':
          this.dialogDataVisit = this.visit;
          break;
        case 'visits':
          this.$router.push({ path: this.$store.state.fromPage });
          break;
      }
    },

    onStatusChange(value) {
      this.dialogData = value;
    },

    onStatusChangeVisit(value) {
      this.dialogDataVisit = value;
    },

    onActionAdd() {
      this.$store.commit('actions/FILTER', '');
      this.$store.commit('actions/SELECT', null);
      this.dialogData = {
        id: null,
        visit_id: this.visit.id,
        status: 1
      };
    },

    closeVisit() {
      let visitData = { ...this.visit };
      visitData.status = 1;
      delete visitData.created_at;
      delete visitData.updated_at;
      this.processing = true;
      this.$store
        .dispatch(`visits/EDIT`, visitData)
        .then(response => {
          this.processing = false;
          this.$router.push({ path: this.$store.state.fromPage });
        })
        .catch(error => {
          if (error.response.data.errors) {
            this.processing = false;
            this.errorMessages = error.response.data.errors;
          } else {
            this.processing = false;
            this.errorMessageGeneric = 'A apărut o eroare la salvare.';
          }
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/VisitView.vue